<template>
  <div class="consent">
    <b-modal v-model="is_newsletter_consent_modal_active" :can-cancel="false" :aria-modal="true">
      <div class="card">
        <div class="card-content">
          <div class="media">
            <div class="media-content">
              <span class="title is-4">{{ $t('subscribe.newsletter_and_special_offers_subscription') }}</span>
            </div>
          </div>
          <div class="content">
            <p>
              {{ $t('subscribe.we_are_happy_you_subscribed') }}
              {{ $t('subscribe.if_you_want_to_renew_subscription') }}
            </p>
            <hr>
            <button class="button is-primary" @click="updateConsent(1)">
              {{ $t('subscribe.yes_accept') }}
            </button>
            <button class="button is-light" @click="updateConsent(0)">
              {{ $t('subscribe.no_thank_you') }}
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style scoped>
.consent{
  font-family: Calibri, sans-serif !important;
}
.consent p {
  font-size: 14px !important;
}
.consent .content {
  font-size: 14px !important;
}
</style>

<script>

export default {
  name: 'NewsletterConsent',
  data() {
    return {
      is_newsletter_consent_modal_active: true
    };
  },
  mounted() {
    VueEventHub.$on('open-newsletter-consent-modal', this.openCookieConsentModal);
  },
  methods: {
    openNewsletterConsentModal() {
      this.is_newsletter_consent_modal_active = true;
    },
    closeNewsletterConsentModal() {
      this.is_newsletter_consent_modal_active = false;
    },
    updateConsent(is_accepted) {
      this.closeNewsletterConsentModal();
      axios.patch('/profile/update-newsletter-consent', { 'opt_in': is_accepted });
    }
  }
};
</script>
